import React, { useLayoutEffect } from "react";
import { IoChevronBack } from "react-icons/io5";
import styles from './ArtistAlbum.module.css';
// custom component
import SongCard from "../../components/reusable/SongCard";
// loading state
import HomePageSkeleton from "../../components/skeletonLoading/HomePageSkeleton";
import MusicAlbumSeeAllLoading from "../../components/skeletonLoading/musicAlbumListLoading/MusicAlbumListLoading";

import FlatList from "../../components/FlatList";

// custom context
import { useNavbar } from "../../context/NavBarContext";

import { NotFound } from "../error/NotFound_404";

import { useFetchMusicArtistSongDataQuery } from "../../api/musicArtistSongPageApi";
import { useNavigate, useParams } from "react-router";
import { useMusic } from "../../context/MusicContext";
import { useFetchMusicArtistAlbumDataQuery } from "../../api/musicArtistAlbumPageApi";

const Index = () => {
    const navigate = useNavigate();
  const musicContext = useMusic();
  const Navbar = useNavbar();
  const { artist_id } = useParams();

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  },[])

  const { data, error, isLoading, isFetching } =
    useFetchMusicArtistAlbumDataQuery({
      artist_id: artist_id,
    });

  if (isLoading) {
    return <MusicAlbumSeeAllLoading />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  const handleAlbumClick = (albumId) => {
    navigate(`/music/detail/album/${albumId}`);
  }

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
    {data.result.map((item) => (
      <div key={item.id} className="inline-block truncate text-center"
      onClick={() => handleAlbumClick(item.id)}
      >
          <img
            src={item.image}
            alt=""
            className="rounded-lg w-100 object-cover aspect-square"
          />
        {/* <img src={item.image} alt="" className="rounded-lg w-100 object-cover aspect-square" /> */}
        <span className="text-xs mt-2">{item.title}</span>
      </div>
    ))}
  </div>
  );
};

export default Index;
